// "4,120 / 4,000" in the field's bottom-right corner, only while over the limit, so
// it takes no line of its own
export const LengthCounter = ({
  length,
  limit,
}: {
  length: number;
  limit: number;
}) =>
  length > limit ? (
    <span className="pointer-events-none absolute bottom-0 right-[calc(4*var(--ac-u))] rounded-sm bg-surface px-[calc(4*var(--ac-u))] text-[length:calc(11*var(--ac-u))] leading-[calc(16*var(--ac-u))] tabular-nums text-danger-11">
      {length.toLocaleString()} / {limit.toLocaleString()}
    </span>
  ) : null;
